import { useEffect, useRef } from "react";
import { useSiteContent } from "../../../context/SiteContentContext";

export default function BrandLogos() {
  const { content } = useSiteContent();
  const logos = content.brand_logos.map((b: { name: string; logo: string }) => ({ src: b.logo, alt: b.name }));
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    let pos = 0;
    let raf: number;
    const step = () => {
      pos -= 0.6;
      const half = track.scrollWidth / 2;
      if (Math.abs(pos) >= half) pos = 0;
      track.style.transform = `translateX(${pos}px)`;
      raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, []);

  const doubled = [...logos, ...logos];

  return (
    <div className="w-full relative overflow-hidden" style={{ background: "#fff", borderTop: "1px solid rgba(74,159,212,0.1)", borderBottom: "1px solid rgba(74,159,212,0.1)" }}>
      <div className="max-w-7xl mx-auto px-8 py-6">
        <p className="text-center text-xs font-bold uppercase tracking-widest mb-6" style={{ color: "#4a9fd4" }}>
          Trusted Brands We Work With
        </p>
      </div>

      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none" style={{ background: "linear-gradient(to right,#fff,transparent)" }} />
      <div className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none" style={{ background: "linear-gradient(to left,#fff,transparent)" }} />

      <div className="relative flex overflow-hidden pb-8">
        <div ref={trackRef} className="flex items-center gap-14 will-change-transform" style={{ whiteSpace: "nowrap" }}>
          {doubled.map((logo, i) => (
            <div key={i} className="flex-shrink-0 w-28 h-10 flex items-center justify-center opacity-40 hover:opacity-80 transition-opacity duration-300 cursor-pointer">
              <img
                src={logo.src}
                alt={logo.alt}
                className="max-h-9 max-w-full object-contain"
                style={{ filter: "grayscale(100%)" }}
                onError={(e) => { (e.target as HTMLImageElement).style.opacity = "0"; }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
